/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./Home.css";
import pdfImage from "../../assets/icon_pdf.png";
import { useDispatch, useSelector } from "react-redux";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import { fetchReports } from "../../app/slices/reportsSlice";
import { dateFormat } from "../../app/utils";
import moment from "moment";
import { fetchAdvisories } from "../../app/slices/advisoriesSlice";
import { fetchAlerts } from "../../app/slices/alertsSlice";
import { fetchEvents } from "../../app/slices/eventsSlice";

const Home = () => {
  const {
    data: reportsList,
    status: statusReports,
    // error: errorReports,
  } = useSelector(({ reports }) => reports.get);
  const {
    data: advisoriesList,
    status: statusAdvisories,
    // error: errorAdvisories,
  } = useSelector(({ advisories }) => advisories.get);
  const {
    data: alertsList,
    status: statusAlerts,
    // error: errorAlerts,
  } = useSelector(({ alerts }) => alerts.get);
  const {
    data: eventsList,
    status: statusEvents,
    // error: errorEvents,
  } = useSelector(({ events }) => events.get);

  const dispatch = useDispatch();

  //use effect
  useEffect(() => {
    dispatch(
      fetchAlerts({
        limit: 4,
        status: "A",
      })
    );
    dispatch(
      fetchEvents({
        limit: 4,
        status: "A",
      })
    );
    dispatch(
      fetchReports({
        limit: 4,
        status: "A",
      })
    );
    dispatch(
      fetchAdvisories({
        limit: 4,
        status: "A",
      })
    );
  }, []);

  //builders
  const EventSlider = () => {
    return (
      <Swiper
        pagination={{
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: true,
        }}
        modules={[Pagination, Autoplay]}
        className="event-swiper"
      >
        {eventsList?.map((event) => (
          <SwiperSlide>
            <a href={`/events/event-details?id=${event?.event_id}`}>
              <div className="event-slider-slide">
                <img
                  src={`${process.env.REACT_APP_SERVER_URL}/uploads/events/${event?.cover_image}`}
                  alt=""
                />
                <div className="shader">
                  <div className="text">
                    <h2>{event?.title}</h2>
                    <p className="mt-5">
                      {event?.description?.length > 300
                        ? `${event?.description?.substring(0, 299)}...`
                        : event?.description}
                    </p>
                    <small className="mt-5">
                      {moment(event.event_date).format("DD-MMM-YYYY")}
                    </small>
                  </div>
                </div>
              </div>
            </a>
          </SwiperSlide>
        ))}

        {statusEvents === "loading" && (
          <SwiperSlide>
            <LoadingContainer message={"Loading latest events..."} />
          </SwiperSlide>
        )}
      </Swiper>
    );
  };

  const LatestUpdates = () => {
    return (
      <div className="latest-updates-container">
        <h1 className="mb-30">LATEST UPDATES</h1>
        <div className="flex-row align-items-center justify-content-space-between">
          <div>
            <h2 className="mb-10 text-primary bolder">Alerts</h2>
          </div>
          <div className="bolder text-accent text-align-right">
            <a href="/alerts">SEE ALL ALERTS</a>
          </div>
        </div>

        <div className="flex-row flex-wrap mb-30">
          {alertsList?.map((alert) => (
            <a href={`/alerts/alert-details?id=${alert?.alert_id}`}>
              <div className="alert-item">
                <img
                  src={`${process.env.REACT_APP_SERVER_URL}/uploads/alerts/${alert?.cover_image}`}
                  alt=""
                />
                <div className="shader">
                  <h3>{alert?.title}</h3>
                  <small className="mt-5">
                    {moment(alert?.published_date)?.format("DD-MMM-YYYY")}
                  </small>
                </div>
              </div>
            </a>
          ))}
        </div>
        {statusAlerts === "loading" && (
          <LoadingContainer message={"Loading alerts..."} />
        )}

        <div className="flex-row align-items-center justify-content-space-between">
          <div>
            <h2 className="mb-10 text-primary bolder">Advisories</h2>
          </div>
          <div className="bolder text-align-right">
            <a href="/advisories">SEE ALL ADVISORIES</a>
          </div>
        </div>

        {statusAdvisories !== "loading" && advisoriesList?.length > 0 && (
          <div className="flex-row flex-wrap mb-30">
            {advisoriesList?.map((advisory) => (
              <a
                href={`advisories/advisory-details?id=${advisory?.advisory_id}`}
              >
                <div className="advisory-item">
                  <h3>{advisory?.title}</h3>
                  <small>Reference:</small>
                  <p>{advisory?.reference_number}</p>
                  <small>Published On:</small>
                  <p>{moment(advisory?.published_date).format(dateFormat)}</p>
                </div>
              </a>
            ))}
          </div>
        )}

        {statusAdvisories === "loading" && (
          <LoadingContainer message={"Loading advisories..."} />
        )}

        <div className="flex-row align-items-center justify-content-space-between">
          <div>
            <h2 className="mb-10 text-primary bolder">Reports</h2>
          </div>
          <div className="bolder text-align-right">
            <a href="/reports">SEE ALL REPORTS</a>
          </div>
        </div>

        {reportsList?.length > 0 && statusReports !== "loading" && (
          <div className="flex-row flex-wrap mb-30">
            {reportsList?.map((report) => (
              <a
                href={`${process.env.REACT_APP_SERVER_URL}/uploads/reports/${report?.attachment}`}
                target="_blank"
              >
                <div className="report-item">
                  <div className="flex-row justify-content-center mb-5">
                    <img src={pdfImage} alt="PDF" />
                  </div>
                  <h3>{report?.title}</h3>
                  <small>Description:</small>
                  <p>
                    {report?.description?.length > 100
                      ? report?.description?.substring(0, 99)
                      : report?.description}
                  </p>
                  <small>Published On:</small>
                  <p>{moment(report?.published_date).format(dateFormat)}</p>
                </div>
              </a>
            ))}
          </div>
        )}

        {statusReports === "loading" && (
          <LoadingContainer message={"Loading reports..."} />
        )}
      </div>
    );
  };

  return (
    <div className="home">
      {/* event slider */}
      <section className="mb-30">{EventSlider()}</section>

      {/* latest updates */}
      <section className="mb-30 app-padding">{LatestUpdates()}</section>
    </div>
  );
};

export default Home;
